import { Component, inject, OnInit } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { Store } from "@ngxs/store";
import { Tag } from "@vp/models";
import * as TagManagerActions from "@vp/tag-manager/data-access/tag-manager-state";
import { TagManagerState } from "@vp/tag-manager/data-access/tag-manager-state";

import { filterNullMap } from "@vp/shared/operators";
import { BehaviorSubject, combineLatest, map, Observable, of, switchMap, take, tap } from "rxjs";
import { AddRecipientsDialogComponent } from "../add-recipients-dialog/add-recipients-dialog.component";
@Component({
  selector: "vp-add-recipients",
  standalone: false,
  templateUrl: "./add-recipients.component.html",
  styleUrl: "./add-recipients.component.scss"
})
export class AddRecipientsComponent extends FieldType<FieldTypeConfig> implements OnInit {
  selectedTag$: Observable<Tag | null> = inject(Store).select(TagManagerState.selectedTag);

  private readonly recipients$$ = new BehaviorSubject<string[]>([]);

  recipients$ = this.recipients$$.asObservable();

  constructor(
    private readonly matDialog: MatDialog,
    private readonly store: Store
  ) {
    super();
  }

  ngOnInit() {
    this.selectedTag$
      .pipe(
        filterNullMap(),
        take(1),
        tap((tag: Tag) => {
          this.recipients$$.next((tag?.tagData?.addRecipients as string[]) || []);
        })
      )
      .subscribe();
  }

  removeRecipient(recipient: string) {
    const newRecipients = this.recipients$$.getValue().filter(x => x !== recipient);
    this.recipients$$.next(newRecipients);
    this.selectedTag$
      .pipe(
        filterNullMap(),
        take(1),
        map((tag: Tag) => {
          this.store.dispatch(new TagManagerActions.DeleteRecipient(tag.tagId, recipient));
        })
      )
      .subscribe();
  }

  addNewRecipient() {
    this.selectedTag$
      .pipe(
        filterNullMap(),
        take(1),
        switchMap((tag: Tag) =>
          combineLatest([
            of(tag),
            this.matDialog
              .open(AddRecipientsDialogComponent, {
                disableClose: true,
                width: "30vw",
                data: {}
              } as MatDialogConfig)
              .afterClosed()
              .pipe(filterNullMap())
          ])
        ),
        map(([tag, recipientAdded]: [Tag, string]) => {
          const newRecipients = [
            ...((tag?.tagData?.addRecipients as string[]) || []),
            recipientAdded
          ];
          this.recipients$$.next(newRecipients);
          this.store.dispatch(new TagManagerActions.AddRecipient(tag.tagId, recipientAdded));
        })
      )
      .subscribe();
  }
}
